import React from 'react';
import {Button} from 'antd';
import useApiPermission from '../../hooks/useApiPermission';

/**
 * PermissionButton
 * AntD Button에 권한 체크를 결합합니다.
 * props:
 *  - require: function | {method,url} | Array<...>
 *  - disabledIfDenied?: boolean (기본 true)
 *  - hideIfDenied?: boolean (기본 false)
 * 나머지 props는 Button으로 전달됩니다.
 */
export default function PermissionButton({ require, disabledIfDenied = true, hideIfDenied = false, children, ...rest }) {
  const { canCall, loading } = useApiPermission();
  const requirements = Array.isArray(require) ? require : [require];
  const allowed = requirements.every((r) => (r ? canCall(r) : true));

  if (!allowed && hideIfDenied) return null;

  const computedDisabled = disabledIfDenied && (!allowed || loading) ? true : rest.disabled;

  return (
    <Button {...rest} disabled={computedDisabled}>
      {children}
    </Button>
  );
}

